import { defineComponent } from "vue";

import { helperTestingAgency } from "../../common/vue-helpers/testing-agency-check";
import CentralIntakeRouter from "./CentralIntakeRouter";

import LevelTwo from "../LevelTwo/LevelTwo.vue";

export default defineComponent({
    components: {
        LevelTwo
    },
    data() {
        return {
            router: null
        };
    },
    async mounted() {
        const isTestAgency =
            (await helperTestingAgency.checkHasTestingAgency()) ||
            (await helperTestingAgency.checkHasExternalReferralTestingAgencies());
        this.router = CentralIntakeRouter?.filter((route: any) => {
            if (!!route.meta?.showExternalReferral) {
                return isTestAgency;
            } else {
                return true;
            }
        });
    }
});
